import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-membership-guest',
		path: '/admin/membership/:id',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_membership" */ './index'), {
			exportName: 'AdminMembership',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: true,
	},
];
